module.exports = __webpack_public_path__ + "static/img/page29.23076d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page29.jpg
// module id = AuAI
// module chunks = 0